import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import amplitude from 'amplitude-js'
import 'firebase/analytics'
import firebase from 'firebase/app'
import 'firebase/firestore' // for db initialization
import 'firebase/functions'
import { amplitudeApiKeyDev, amplitudeApiKeyProduction } from '@/services/tracking'
import Vue from 'vue'
import { debug, enableEmulators } from './config'
import firebaseConfig from './config/firebase'

if (!debug) {
  Sentry.init({
    dsn: 'https://0e95d23d6df94550a1d6d7d6b16d3b58@o406556.ingest.sentry.io/5276827',
    integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
  })
}

export const app = firebase.initializeApp(firebaseConfig)

if (enableEmulators) {
  firebase.functions().useEmulator('localhost', 5001)
}
if (process.env.NODE_ENV !== 'test') {
  // Avoid: UnhandledPromiseRejectionWarning: IDB requires a browser environment
  // when running tests
  firebase.analytics()
}

export const amplitudeClientDev = amplitude.getInstance('Renderro-DEV')
export const amplitudeClientProduction = amplitude.getInstance('Renderro')

amplitudeClientDev.init(amplitudeApiKeyDev)
if (debug) {
  // When running locally on localhost:8080 even the production amplitude uses dev api keys to avoid clutter
  amplitudeClientProduction.init(amplitudeApiKeyDev, undefined, {
    includeGclid: true,
    includeUtm: true,
    includeReferrer: true,
    sameSiteCookie: 'Lax',
  })
} else {
  amplitudeClientProduction.init(amplitudeApiKeyProduction, undefined, {
    includeGclid: true,
    includeUtm: true,
    includeReferrer: true,
    sameSiteCookie: 'Lax',
  })
}
